import styled from "styled-components";

export const Container = styled.div`
  margin-bottom: 8rem;
`;

export const Content = styled.div`
  max-width: 1220px;
  margin: 0 auto;
  padding: 2rem 1rem 3rem;

  display: flex;
  flex-direction: row;
  align-items: flex-start;
  justify-content: space-between;

  @media (max-width: 900px) {
    flex-direction: column-reverse;
    align-items: center;
  }

  p {
    font-size: 3rem;
    font-family: 'Poppins', sans-serif;
    font-weight: 700;
    color: ${props => props.theme['text-title']};
    line-height: 4.5rem;
  }

  img {
    transform: rotate(270deg);
    height: 350px;
    width: 350px;
    object-fit: cover;
    border-radius: 250px;

    @media (max-width: 480px) {
      height: 300px;
      width: 300px;
    }
  }

  div {
    &.photoCover{
      display: flex;
      justify-content: center;
      align-items: center;

      height: 370px;
      width: 370px;
      border-radius: 250px;
      background-image: linear-gradient(#E70FAA, #00C0FD);

      @media (max-width: 480px) {
        height: 315px;
        width: 315px;
      }
    }
  }
`;